import T from '@/components/Helpers/Translate'
import { Skeleton } from '@/components/_ui/Skeleton'
import { useGetProductRecommendations } from '@/lib/hooks/services/useGetProductRecommendations'
import CartSheetRecommendedProductsCarousel from './CartSheetRecommendedProductsCarousel/Carousel'
import CartSheetRecommendedProductsCarouselItem from './CartSheetRecommendedProductsCarousel/CarouselItem'

const CartSheetRecommendedProducts = () => {
  const { isLoading, recommendedProducts } = useGetProductRecommendations({})

  if (isLoading) {
    return (
      <div className="p-5">
        <span className="text-2xl text-primary ">
          <T>you_might_also_like</T>
        </span>
        <div className="flex space-x-4">
          <Skeleton className="h-64 w-1/2 rounded-lg" />
          <Skeleton className="h-64 w-1/2 rounded-lg" />
        </div>{' '}
      </div>
    )
  }

  if (!recommendedProducts) return null

  return (
    <div className="p-5">
      <span className="text-2xl text-primary ">
        <T>you_might_also_like</T>
      </span>
      <CartSheetRecommendedProductsCarousel>
        {recommendedProducts.map((product, index) => (
          <CartSheetRecommendedProductsCarouselItem
            key={product.slug}
            product={product}
            index={index}
          />
        ))}
      </CartSheetRecommendedProductsCarousel>
    </div>
  )
}

export default CartSheetRecommendedProducts
